import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'
import './Pager.scss'
import Pagination from './Pagination'

class Pager extends Component {
  render() {
    const { prev, next, numPages, currentPage } = this.props
    return (
      <div className="pager">
        {prev && (
          <div className="forward">
            <Link
              to={`/${this.props.type === 'post' ? 'blog' : 'video'}`}
              className="pager-first more-link"
            >
              First
            </Link>{' '}
            <Link to={prev} className="pager-prev more-link">
              Previous
            </Link>
          </div>
        )}
        {!prev && <div></div>}
        <Pagination
          numPages={numPages}
          currentPage={currentPage}
          pageNeighbors={2}
          type={this.props.type}
        />
        {next && (
          <div className="backward">
            <Link to={next} className="pager-next more-link">
              Next
            </Link>{' '}
            <Link
              to={
                `/${this.props.type === 'post' ? 'blog' : 'video'}/page` +
                numPages
              }
              className="pager-last more-link"
            >
              Last
            </Link>
          </div>
        )}
        {!next && <div></div>}
      </div>
    )
  }
}

Pager.propTypes = {
  next: PropTypes.string,
  prev: PropTypes.string,
}

export default Pager
